import styled from "@emotion/styled";
import React from "react";
import useCaregiver from "../../hooks/useCaregiver";
import { useFlexibleAppUpdate } from "../../hooks/useFlexibleAppUpdate";
import { isLoading } from "../../Loading";
import { MEDFLYT_LOGO_TEXT_ONLY } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";
import Spinner from "../Generic/Spinner";
import MainV2Activity, { MainV2ActivityProps } from "../MainV2Screen/MainV2Activity";
import MainActivity, { MainActivityProps } from "./MainActivity";

type Props = {
  v2Props: Omit<MainV2ActivityProps, "caregiver">;
  v1Props: MainActivityProps;
};

export default function MainActivityController({ v1Props, v2Props }: Props) {
  useFlexibleAppUpdate();

  const caregiver = useCaregiver(v1Props.appState);

  if (isLoading(caregiver)) {
    return (
      <Root>
        <AppIcon icon={MEDFLYT_LOGO_TEXT_ONLY} size={80} />
        <Spinner size={32} speed={0.5} />
      </Root>
    );
  }

  return (
    <>
      {caregiver.shouldShowMainV2Screen ? (
        <MainV2Activity {...v2Props} caregiver={caregiver} />
      ) : (
        <MainActivity {...v1Props} />
      )}
    </>
  );
}

const Root = styled.div`
  background-color: white;
  height: 100%;
  color: var(--primary-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
